import React from "react";
import { Box, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

function formatDate(dateISO) {
  if (!dateISO) return "";
  const date = new Date(dateISO);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-PK", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

function BlogCard({ post, categoryName }) {
  if (!post) return null;

  return (
    <Card
      component={RouterLink}
      to={`/blog/${post.slug}`}
      sx={{
        textDecoration: "none",
        color: "inherit",
        border: "1px solid",
        borderColor: "divider",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: (theme) => theme.shadows[4],
        },
      }}
    >
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
          {categoryName ? <Chip size="small" label={categoryName} variant="outlined" /> : null}
          <Typography variant="caption" color="text.secondary">
            {formatDate(post.updatedISO || post.dateISO)}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {post.readingMinutes || 1} min read
          </Typography>
        </Stack>
        <Typography variant="h6" component="h3" sx={{ mb: 1 }}>
          {post.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          {post.description}
        </Typography>
        <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
          {(post.tags || []).slice(0, 3).map((tag) => (
            <Chip
              key={`${post.id}-${tag}`}
              label={tag}
              size="small"
              component={RouterLink}
              to={`/blog/tag/${encodeURIComponent(tag.toLowerCase())}`}
              clickable
              onClick={(event) => event.stopPropagation()}
              sx={{ textDecoration: "none" }}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}

export default BlogCard;
